import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  BioForm,
  MetaSetter,
  RequestLoaderTrigger,
} from "components/secondaryComponents";
import { LoginLayout } from "layout";
import { motion } from "framer-motion";
import { setApiErrorMessage } from "store/modules/apiErrorHandler";
import useSelfRegistration from "./useSelfRegistration";

const CustomerSelfRegistration = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasRegistrationState = Boolean(
    searchParams.get("access_number") &&
      searchParams.get("phone_code") &&
      searchParams.get("business_slug"),
  );
  const registrationData = {
    accessNumber: searchParams.get("access_number"),
    phoneCode: searchParams.get("phone_code"),
    businessSlug: searchParams.get("business_slug"),
  };
  const { data, handleSelfRegistration } =
    useSelfRegistration(registrationData);

  useEffect(() => {
    if (!hasRegistrationState) {
      dispatch(
        setApiErrorMessage(
          "This registration link is invalid or missing. Please log in again.",
        ),
      );
      navigate("/login", { replace: true });
    }
  }, [dispatch, hasRegistrationState, navigate]);

  if (!hasRegistrationState) return null;

  return (
    <MetaSetter
      title="Lumi Merchant Loyalty | Registration"
      description="Complete your registration"
    >
      <RequestLoaderTrigger>
        <LoginLayout>
          <motion.div
            initial={{ marginTop: "50px" }}
            animate={{
              marginTop: "-40px",
              transition: { duration: 0.3, delay: 0.1 },
            }}
          >
            <h4>Enter Your Details</h4>
            <p className="mt-1 mb-4">Provide the following details</p>
            <BioForm
              buttonLoadingText="Registering..."
              buttonText="Register"
              data={data}
              type="self-register"
              onSuccessCall={handleSelfRegistration}
            />
          </motion.div>
        </LoginLayout>
      </RequestLoaderTrigger>
    </MetaSetter>
  );
};

export default CustomerSelfRegistration;
